import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ExpressPaymentMethodByCountry } from '../../../types/CartItemSchema';

type StripeSlice = {
  initialized: boolean;
  initFailed: boolean;
  expressPaymentMethodByCountry: ExpressPaymentMethodByCountry;
};

const initialState: StripeSlice = {
  initialized: false,
  initFailed: false,
  expressPaymentMethodByCountry: {},
};

export const stripeSlice = createSlice({
  name: 'stripe',
  initialState,
  reducers: {
    stripeInitComplete: (state) => {
      state.initialized = true;
    },
    stripeInitFailed: (state) => {
      state.initFailed = true;
    },
    setExpressPaymentMethod: (state, action: PayloadAction<ExpressPaymentMethodByCountry>) => {
      state.expressPaymentMethodByCountry = action.payload;
    },
  },
});

export const { stripeInitComplete, stripeInitFailed, setExpressPaymentMethod } = stripeSlice.actions;
